/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: payor.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  AdminCreatePayorRequest,
  AdminCreatePayorResponse,
  AdminGetPayorRequest,
  AdminGetPayorResponse,
  AdminUpdatePayorRequest,
  AdminUpdatePayorResponse,
  CreatePayorRequest,
  CreatePayorResponse,
  GetPayorBySlugRequest,
  GetPayorBySlugResponse,
  GetPayorByStediIdRequest,
  GetPayorByStediIdResponse,
  GetPayorRequest,
  GetPayorResponse,
  ListPayorsRequest,
  ListPayorsResponse,
  SearchPayorsByNameRequest,
  SearchPayorsByNameResponse,
  UpdatePayorRequest,
  UpdatePayorResponse,
} from '../types/payor';

export const createPayorService = (transport: Transport) => ({
  async createPayor(
    request: CreatePayorRequest,
    options: RequestOptions = {},
  ): Promise<CreatePayorResponse> {
    const url = getApiPath(API_METHODS.PayorService.CreatePayor);
    return transport.post<CreatePayorResponse>(url, request, options);
  },

  async getPayor(
    request: GetPayorRequest,
    options: RequestOptions = {},
  ): Promise<GetPayorResponse> {
    const { payor_id } = request;
    const url = getApiPath(API_METHODS.PayorService.GetPayor, { payor_id });
    return transport.get<GetPayorResponse>(url, options);
  },

  async getPayorBySlug(
    request: GetPayorBySlugRequest,
    options: RequestOptions = {},
  ): Promise<GetPayorBySlugResponse> {
    const { slug } = request;
    const url = getApiPath(API_METHODS.PayorService.GetPayorBySlug, { slug });
    return transport.get<GetPayorBySlugResponse>(url, options);
  },

  async getPayorByStediId(
    request: GetPayorByStediIdRequest,
    options: RequestOptions = {},
  ): Promise<GetPayorByStediIdResponse> {
    const { stedi_id } = request;
    const url = getApiPath(API_METHODS.PayorService.GetPayorByStediId, { stedi_id });
    return transport.get<GetPayorByStediIdResponse>(url, options);
  },

  async updatePayor(
    request: UpdatePayorRequest,
    options: RequestOptions = {},
  ): Promise<UpdatePayorResponse> {
    const { payor_id, ...body } = request;
    const url = getApiPath(API_METHODS.PayorService.UpdatePayor, { payor_id });
    return transport.post<UpdatePayorResponse>(url, body, options);
  },

  async searchPayorsByName(
    request: SearchPayorsByNameRequest,
    options: RequestOptions = {},
  ): Promise<SearchPayorsByNameResponse> {
    const url = getApiPath(API_METHODS.PayorService.SearchPayorsByName);
    return transport.get<SearchPayorsByNameResponse>(url, { params: request, ...options });
  },

  async listPayors(
    request: ListPayorsRequest,
    options: RequestOptions = {},
  ): Promise<ListPayorsResponse> {
    const url = getApiPath(API_METHODS.PayorService.ListPayors);
    return transport.get<ListPayorsResponse>(url, { params: request, ...options });
  },

  async adminCreatePayor(
    request: AdminCreatePayorRequest,
    options: RequestOptions = {},
  ): Promise<AdminCreatePayorResponse> {
    const url = getApiPath(API_METHODS.AdminPayorService.AdminCreatePayor);
    return transport.post<AdminCreatePayorResponse>(url, request, options);
  },

  async adminUpdatePayor(
    request: AdminUpdatePayorRequest,
    options: RequestOptions = {},
  ): Promise<AdminUpdatePayorResponse> {
    const { payor_id, ...body } = request;
    const url = getApiPath(API_METHODS.AdminPayorService.AdminUpdatePayor, { payor_id });
    return transport.post<AdminUpdatePayorResponse>(url, body, options);
  },

  async adminGetPayor(
    request: AdminGetPayorRequest,
    options: RequestOptions = {},
  ): Promise<AdminGetPayorResponse> {
    const { payor_id } = request;
    const url = getApiPath(API_METHODS.AdminPayorService.AdminGetPayor, { payor_id });
    return transport.get<AdminGetPayorResponse>(url, options);
  },
});

export type PayorService = ReturnType<typeof createPayorService>;
